import { useEffect } from "react";

const BASE_TITLE = "Sins II Atlas";

/** Per-page document title — pages set it on mount so SPA navigation and shared deep links
 * both label the tab correctly. */
export function useDocumentTitle(prefix?: string) {
  useEffect(() => {
    document.title = prefix === undefined ? BASE_TITLE : `${prefix} · ${BASE_TITLE}`;
  }, [prefix]);
}
